/**
 * アプリの中の共通レイアウト。
 *
 * UX1-a でアプリ内ナビは `AppShell` の 232px 列へ移ったので、ここは中身の
 * 余白を揃えるだけの薄い器になった(各画面の中身は触らない)。
 */
import { Navigate, Outlet } from "react-router-dom";

import { useMe } from "../lib/useApi";
import { visibleItems, type AppDef } from "./nav";

export function AppLayout() {
  return (
    <div className="ux-page">
      <Outlet />
    </div>
  );
}

/**
 * `/<app>` に来たときに開くページ。
 *
 * `def.defaultPath` が契約に入っていないと、開いた瞬間に 403 の画面になる
 * (「タイルを押したら 403」)。**いま出せるナビ項目の 1 つ目**へ送る。
 */
export function AppIndex({ def }: { def: AppDef }) {
  const me = useMe();
  if (me.isLoading) return null;

  const visible = visibleItems(def, me.data);
  const fallback = visible.find((it) => it.path === def.defaultPath) ?? visible[0];
  // 1 つも出せないときは既定のまま送る(サーバーが 403 を返して理由が出る)
  return <Navigate to={fallback?.path ?? def.defaultPath ?? ""} replace />;
}
